import React from "react";
import SEO from "@/components/SEO";
import Hero from "@/components/Hero";
import IntroSection from "@/components/IntroSection";
import ServicesSection from "@/components/ServicesSection";
import VideoSection from "@/components/VideoSection";
import WhyChooseUs from "@/components/WhyChooseUs";
import ProcessSection from "@/components/ProcessSection";
import ProtectionSection from "@/components/ProtectionSection";
import ReviewsSection from "@/components/ReviewsSection";
import ServiceAreasSection from "@/components/ServiceAreasSection";
import QuoteSection from "@/components/QuoteSection";
import FaqSection from "@/components/FaqSection";
import FinalCTA from "@/components/FinalCTA";
import { FAQS } from "@/data/site";

const HomePage = () => {
  const faqSchema = {
    "@context": "https://schema.org",
    "@type": "FAQPage",
    mainEntity: FAQS.map((f) => ({
      "@type": "Question",
      name: f.q,
      acceptedAnswer: { "@type": "Answer", text: f.a },
    })),
  };

  return (
    <>
      <SEO
        title="Wyoming Moving Company | Crosstown Movers — Casper, Cheyenne & Beyond, Since 1980"
        description="Trusted Wyoming moving company serving Casper, Cheyenne, Laramie & beyond. Local & long-distance movers, licensed & insured, 4.5★ rated. Free quotes. Call (307) 265-8291."
        path="/"
        extraSchema={faqSchema}
      />
      <Hero />
      <IntroSection />
      <ServicesSection />
      <VideoSection />
      <WhyChooseUs />
      <ProcessSection />
      <ProtectionSection />
      <ReviewsSection />
      <ServiceAreasSection />
      <QuoteSection />
      <FaqSection />
      <FinalCTA />
    </>
  );
};

export default HomePage;
